import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import Target from './../Target';
import { FloorplanWrapper } from './Floorplan.styled';

const Floorplan = ({
  data,
  dragging,
  handleDotClick,
  onMouseDown,
  onTouchEnd,
  onTouchMove,
  onTouchStart,
  position,
  selectedIndex,
  zoomed,
  smallScreen,
}) => {
  const [styles, setStyles] = useState({
    left: isNaN(position?.x) ? '0px' : position.x + 'px',
    top: isNaN(position?.y) ? '0px' : position.y + 'px',
  });

  useEffect(() => {
    if (!isNaN(position?.x) && !isNaN(position?.y)) {
      setStyles({
        left: position.x + 'px',
        top: position.y + 'px',
      });
    }
  }, [position]);

  return (
    <FloorplanWrapper
      id="ifp-floorplan"
      dragging={dragging}
      zoomed={zoomed}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      onMouseDown={(e) => onMouseDown(e)}
      style={styles}
    >
      {data.map((item, index) => {
        let selected = false;
        if (selectedIndex >= 0 && selectedIndex === index) selected = true;

        return (
          <Target
            key={index}
            item={item}
            id={'target-' + index}
            selected={selected}
            handleDotClick={() => handleDotClick(item, index)}
            smallScreen={smallScreen}
          />
        );
      })}
    </FloorplanWrapper>
  );
};

Floorplan.propTypes = {
  data: PropTypes.array,
  dragging: PropTypes.any,
  handleDotClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  onTouchEnd: PropTypes.any,
  onTouchMove: PropTypes.any,
  onTouchStart: PropTypes.any,
  position: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  }),
  selectedIndex: PropTypes.number,
  zoomed: PropTypes.any,
  smallScreen: PropTypes.any,
};

export default Floorplan;
